import dummy from '../assets/images/dummy.svg'

////////////////////////////// Start 204
export const configuratorData204 = {
  tokenUrl: '9b79efa0-e369-373c-bee6-f81241207a1d',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData204 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData204 = [
  {
    id: 1,
    name: 'Large Charlie Buffet',
    thumb: dummy,
  },
]

export const sceneData204 = [
  {
    id: 15404,
    name: 'Large Charlie Buffet',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

////////////////////////////// Start 198
export const configuratorData198 = {
  tokenUrl: '2fd1709f-fb51-3f02-9778-bc0d010344c5',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData198 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData198 = [
  {
    id: 1,
    name: 'Wendy Side Table',
    thumb: dummy,
  },
]

export const sceneData198 = [
  {
    id: 15398,
    name: 'Wendy Side Table',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
////////////////////////////// Start 136
export const configuratorData136 = {
  tokenUrl: 'c44c8016-783a-3a50-b496-62d7ef34919f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData136 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData136 = [
  {
    id: 2,
    name: 'No Cushion',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'New Windsor Arm Chair',
    thumb: dummy,
  },
]

export const sceneData136 = [
  {
    id: 26115,
    name: 'New Windsor Arm Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 26116,
    name: 'New Windsor Arm Chair - Without Cushion',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

////////////////////////////// Start 130
export const configuratorData130 = {
  tokenUrl: '08017b96-b65e-3b29-ac3c-97efb28662c9',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData130 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData130 = [
  {
    id: 2,
    name: 'No Cushion',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Judy Dining Chair',
    thumb: dummy,
  },
]

export const sceneData130 = [
  {
    id: 24830,
    name: 'Judy Dining Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24870,
    name: 'Judy Dining Chair - Without Cushion',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

////////////////////////////// Start 91
export const configuratorData91 = {
  tokenUrl: 'b0d5deda-78a7-3460-bf21-27187d117747',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData91 = [
  {
    id: 1,
    name: 'Bed',
    thumb: dummy,
  },
]

export const layoutData91 = [
  {
    id: 2,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 4,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 3,
    name: 'Double',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'King',
    thumb: dummy,
  },
]

export const sceneData91 = [
  {
    id: 24353,
    name: 'Meriweather Bed King',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24352,
    name: 'Meriweather Bed Queen',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24354,
    name: 'Meriweather Bed Double',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24355,
    name: 'Meriweather Bed Twin',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  },
]

////////////////////////////// Start 26
export const configuratorData26 = {
  tokenUrl: '20b4dfcf-5a98-3cf2-bcf3-f8fbbccc7e17',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData26 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData26 = [
  {
    id: 1,
    name: 'Quinn Chair',
    thumb: dummy,
  },
]

export const sceneData26 = [
  {
    id: 24837,
    name: 'Quinn Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


////////////////////////////// Start 19
export const configuratorData19 = {
  tokenUrl: 'f0aac823-f989-32ae-993f-d98f1b602a98',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData19 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData19 = [
  {
    id: 1,
    name: 'Margot Chair',
    thumb: dummy,
  },
]

export const sceneData19 = [
  {
    id: 24831,
    name: 'Margot Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

////////////////////////////// Start 46
export const configuratorData46 = {
  tokenUrl: '81bc9747-7781-32a5-ab72-27142129ea30',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData46 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData46 = [
  {
    id: 1,
    name: 'Francine Sofa',
    thumb: dummy,
  },
]

export const sceneData46 = [
  {
    id: 24508,
    name: 'Francine Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

////////////////////////////// Start 7
export const configuratorData7 = {
  tokenUrl: 'a2f7a323-9a98-3f0b-a50b-0924c23ac887',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData7 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData7 = [
  {
    id: 1,
    name: 'Daphne Chair',
    thumb: dummy,
  },
]

export const sceneData7 = [
  {
    id: 24833,
    name: 'Daphne Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

////////////////////////////// Start 221
export const configuratorData221 = {
  tokenUrl: 'e0b16ea4-2465-3d70-afb4-55a3783f3d5a',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData221 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData221 = [
  {
    id: 1,
    name: 'Jack Dining Chair',
    thumb: dummy,
  },
]

export const sceneData221 = [
  {
    id: 24834,
    name: 'Jack Dining Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

////////////////////////////// Start 82
export const configuratorData82 = {
  tokenUrl: 'c26632de-5db0-383a-a8eb-1e4af5b3099c',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData82 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData82 = [
    {
    id: 3,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Double',
    thumb: dummy,
  },
  {
    id: 4,
    name: 'King',
    thumb: dummy,
  },
]

export const sceneData82 = [
  {
    id: 24357,
    name: 'Calvin Bed King',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  },
  {
    id: 24356,
    name: 'Calvin Bed Queen',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24358,
    name: 'Calvin Bed Double',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24359,
    name: 'Calvin Bed Twin',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

////////////////////////////// Start 71
export const configuratorData71 = {
  tokenUrl: '41961982-f17d-37cb-bf10-6fe00143fdba',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData71 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData71 = [
  {
    id: 1,
    name: '36',
    name_shopify: '36" - Short Bench',
    thumb: dummy,
  },
  {
    id: 2,
    name: '54',
    name_shopify: '54" - Long Bench',
    thumb: dummy,
  },
  {
    id: 3,
    name: '72',
    name_shopify: '72" - Long Bench',
    thumb: dummy,
  },
]

export const sceneData71 = [
  {
    id: 24931,
    name: 'Paige Bench 36 in',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24835,
    name: 'Paige Bench',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24932,
    name: 'Paige Bench 72 in',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
]

////////////////////////////// Start 83
export const configuratorData83 = {
  tokenUrl: '68c14101-91d0-309a-8f7a-a6a4f22e8152',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData83 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData83 = [
  {
    id: 3,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Double',
    thumb: dummy,
  },
  {
    id: 4,
    name: 'King',
    thumb: dummy,
  },
]

export const sceneData83 = [
  {
    id: 24349,
    name: 'Charlotte Bed King',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  },
  {
    id: 24348,
    name: 'Charlotte Bed Queen',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24466,
    name: 'Charlotte Bed Double',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id:  24467,
    name: 'Charlotte Bed Twin',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

////////////////////////////// Start 162
export const configuratorData162 = {
  tokenUrl: '1e076278-70eb-3b37-aecd-26970072e0fe',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData162 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData162 = [
  {
    id: 2,
    name: 'Textured Silver',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Painted Wood',
    thumb: dummy,
  },
]

export const sceneData162 = [
  {
    id: 15337,
    name: 'Charlotte Bedside Dresser',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 15338,
    name: 'Charlotte Bedside Dresser Steel',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

////////////////////////////// Start 63
export const configuratorData63 = {
  tokenUrl: '68125832-e45a-3da0-be34-c9d715cb3ac0',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData63 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData63 = [
  {
    id: 1,
    name: 'Freya Bench',
    thumb: dummy,
  },
]

export const sceneData63 = [
  {
    id: 24836,
    name: 'Freya Bench',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData40 = {
  tokenUrl: '005f8afc-ce2b-3c19-90d2-3d137dd46ba4',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData40 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData40 = [
  {
    id: 1,
    name: 'Blair Sofa',
    thumb: dummy,
  },
]

export const sceneData40 = [
  {
    id: 24535,
    name: 'Blair Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData41 = {
  tokenUrl: 'a09a585f-2c7a-35de-bf38-0f9d8c133b60',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData41 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData41 = [
  {
    id: 1,
    name: 'Daphne Long Sofa',
    thumb: dummy,
  },
]

export const sceneData41 = [
  {
    id: 24537,
    name: 'Daphne Long Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData42 = {
  tokenUrl: '008b970c-32fe-31ee-b6ca-4b32c127c76c',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData42 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData42 = [
  {
    id: 1,
    name: 'Daphne Sofa',
    thumb: dummy,
  },
]

export const sceneData42 = [
  {
    id: 24538,
    name: 'Daphne Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData59 = {
  tokenUrl: 'de731388-66f4-35b7-b976-9acf0a7c9730',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData59 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData59 = [
  {
    id: 1,
    name: 'Eleanor Ottomon',
    thumb: dummy,
  },
]

export const sceneData59 = [
  {
    id: 24885,
    name: 'Eleanor Ottomon',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData43 = {
  tokenUrl: '1f29301a-daf2-325a-b849-c7c781e3aea0',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData43 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData43 = [
  {
    id: 1,
    name: 'Elle Long Sofa',
    thumb: dummy,
  },
]

export const sceneData43 = [
  {
    id: 24539,
    name: 'Elle Long Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData44 = {
  tokenUrl: '5b2a299f-819f-37a5-adb8-77aae0a98c31',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData44 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData44 = [
  {
    id: 1,
    name: 'Flora Sofa',
    thumb: dummy,
  },
]

export const sceneData44 = [
  {
    id: 24540,
    name: 'Flora Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData45 = {
  tokenUrl: '19cfc09e-72d3-3c56-86a6-842b7b739156',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData45 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData45 = [
  {
    id: 1,
    name: 'Flora Wedge Sofa',
    thumb: dummy,
  },
]

export const sceneData45 = [
  {
    id: 24541,
    name: 'Flora Wedge Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData11 = {
  tokenUrl: '8a27053c-60a0-3106-b72a-f0d71ba34085',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData11 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData11 = [
  {
    id: 1,
    name: 'Gretchen Chair',
    thumb: dummy,
  },
]

export const sceneData11 = [
  {
    id: 24889,
    name: 'Gretchen Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData65 = {
  tokenUrl: 'ae3c067a-fd8b-3510-ab2f-6b3aa07ebe19',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData65 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData65 = [
  {
    id: 1,
    name: 'Lillian Bench',
    thumb: dummy,
  },
]

export const sceneData65 = [
  {
    id: 24894,
    name: 'Lillian Bench',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData20 = {
  tokenUrl: 'b5e876ba-d9c3-3e0e-9685-b770ef2bc95e',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData20 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData20 = [
  {
    id: 1,
    name: 'Max Chair',
    thumb: dummy,
  },
]

export const sceneData20 = [
  {
    id: 24895,
    name: 'Max Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData52 = {
  tokenUrl: 'eacf181d-3648-3761-adca-f7baa0a44ab0',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData52 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData52 = [
  {
    id: 1,
    name: 'Stevie Sofa',
    thumb: dummy,
  },
]

export const sceneData52 = [
  {
    id: 24542,
    name: 'Stevie Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData80 = {
  tokenUrl: '994f7872-0f7d-3a46-b155-cdc2b06074fc',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData80 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData80 = [
  {
    id: 1,
    name: 'Hooks 5',
    thumb: dummy,
  },
]

export const sceneData80 = [
  {
    id: 19372,
    name: 'Hooks 5',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData79 = {
  tokenUrl: '80b8b2a6-f8b1-35ed-bcd6-a68531bb7dfa',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData79 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData79 = [
  {
    id: 1,
    name: 'Hooks 3',
    thumb: dummy,
  },
]

export const sceneData79 = [
  {
    id: 19405,
    name: 'Hooks 3',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData174 = {
  tokenUrl: 'b76ffdd7-980e-36f5-9e70-d375205b1345',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData174 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData174 = [
  {
    id: 2,
    name: 'No Cushion',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Bay Double Window Seat',
    thumb: dummy,
  },
]

export const sceneData174 = [
  {
    id: 24879,
    name: 'Bay Double Window Seat',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24880,
    name: 'Bay Double Window Seat - without_cushion',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData128 = {
  tokenUrl: 'c7a2966c-911c-3719-9035-d98adb005fc5',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData128 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData128 = [
  {
    id: 2,
    name: 'No Cushion',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Judy Counter Stool - Natural - with cushion',
    thumb: dummy,
  },
]

export const sceneData128 = [
  {
    id: 24890,
    name: 'Judy Counter Stool - Natural - with cushion',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24891,
    name: 'No Cushion',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData129 = {
  tokenUrl: '8a090ee5-f584-37b2-9b31-8b35d4330a49',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData129 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData129 = [
  {
    id: 2,
    name: 'No Cushion',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Judy Counter Stool - Painted',
    thumb: dummy,
  },
]

export const sceneData129 = [
  {
    id: 24892,
    name: 'Judy Counter Stool - Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24893,
    name: 'No Cushion',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData285 = {
  tokenUrl: 'fed93c34-ea9b-3b6d-bb62-afa76b65af45',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData285 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData285 = [
  {
    id: 1,
    name: 'Cecilia sofa',
    thumb: dummy,
  },
]

export const sceneData285 = [
  {
    id: 25075,
    name: 'Cecilia sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData286 = {
  tokenUrl: '8e28e173-a69a-3571-bfbd-e01e88ff224f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData286 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData286 = [
  {
    id: 1,
    name: 'Charlie Chair',
    thumb: dummy,
  },
]

export const sceneData286 = [
  {
    id: 24897,
    name: 'Charlie Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData287 = {
  tokenUrl: 'a5f2b6fb-227b-352e-80d8-be58213e0087',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData287 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData287 = [
  {
    id: 1,
    name: 'Cody Apartment Loveseat',
    thumb: dummy,
  },
]

export const sceneData287 = [
  {
    id: 25074,
    name: 'Cody Apartment Loveseat',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData288 = {
  tokenUrl: 'd491c738-716f-3df4-9188-50b354083447',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData288 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData288 = [
  {
    id: 1,
    name: 'Daphne Chair and Half',
    thumb: dummy,
  },
]

export const sceneData288 = [
  {
    id: 24899,
    name: 'Daphne Chair and Half',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData289 = {
  tokenUrl: 'b0e3ab7a-b1d1-3118-8d07-117ee21187e1',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData289 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData289 = [
  {
    id: 1,
    name: 'Libby Chair',
    thumb: dummy,
  },
]

export const sceneData289 = [
  {
    id: 24900,
    name: 'Libby Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData290 = {
  tokenUrl: '6e6b5b32-f60a-3bf2-a6de-f7a2f89cae73',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData290 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData290 = [
  {
    id: 1,
    name: 'Lucy Chair Swivel Glider',
    thumb: dummy,
  },
]

export const sceneData290 = [
  {
    id: 19642,
    name: 'Lucy Chair Swivel Glider',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData291 = {
  tokenUrl: '8a9f9bfb-0709-3634-84fe-695a4fcdfcc9',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData291 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData291 = [
  {
    id: 1,
    name: 'Graham Chair',
    thumb: dummy,
  },
]

export const sceneData291 = [
  {
    id: 24902,
    name: 'Graham Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData292 = {
  tokenUrl: '9ab82ed4-5117-3ec2-9376-6acb1a5687cf',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData292 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData292 = [
  {
    id: 1,
    name: 'Marnie Chair',
    thumb: dummy,
  },
]

export const sceneData292 = [
  {
    id: 24903,
    name: 'Marnie Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData293 = {
  tokenUrl: 'd7a2c893-d016-3a97-a910-53aa6f5b8b45',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData293 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData293 = [
  {
    id: 1,
    name: 'Martha Settee',
    thumb: dummy,
  },
]

export const sceneData293 = [
  {
    id: 24904,
    name: 'Martha Settee',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData294 = {
  tokenUrl: 'fcd9d566-2e2e-3113-9921-62183da31957',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData294 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData294 = [
  {
    id: 1,
    name: 'Monterey Barrel Back Swivel Chair',
    thumb: dummy,
  },
]

export const sceneData294 = [
  {
    id: 19646,
    name: 'Monterey Barrel Back Swivel Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData295 = {
  tokenUrl: 'c684f14f-580a-3595-ba16-6ae5a571aae5',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData295 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData295 = [
  {
    id: 1,
    name: 'Monterey Chair',
    thumb: dummy,
  },
]

export const sceneData295 = [
  {
    id: 19647,
    name: 'Monterey Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData296 = {
  tokenUrl: '2700e334-6b77-3b9a-bb43-854c9eccbef4',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData296 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData296 = [
  {
    id: 1,
    name: 'Monterey Sofa',
    thumb: dummy,
  },
]

export const sceneData296 = [
  {
    id: 19648,
    name: 'Monterey Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData297 = {
  tokenUrl: 'c24edc40-3304-31e4-8312-d2cf9a032b10',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData297 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData297 = [
  {
    id: 1,
    name: 'Nantucket Chair and Half',
    thumb: dummy,
  },
]

export const sceneData297 = [
  {
    id: 19649,
    name: 'Nantucket Chair and Half',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData298 = {
  tokenUrl: 'f02b1ccb-6e7c-3547-8dbc-1beb11cb6697',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData298 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData298 = [
  {
    id: 1,
    name: 'Palm Beach Chair',
    thumb: dummy,
  },
]

export const sceneData298 = [
  {
    id: 19652,
    name: 'Palm Beach Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData299 = {
  tokenUrl: 'ce230a6e-c1ce-34f8-8a90-c60106e8b3f4',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData299 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData299 = [
  {
    id: 1,
    name: 'Sam Chair',
    thumb: dummy,
  },
]

export const sceneData299 = [
  {
    id: 24912,
    name: 'Sam Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData300 = {
  tokenUrl: 'd7dc1fad-bf4d-3729-92f5-1ce957a87c50',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData300 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData300 = [
  {
    id: 1,
    name: 'Nantucket Sofa 2',
    thumb: dummy,
  },
]

export const sceneData300 = [
  {
    id: 19650,
    name: 'Nantucket Sofa 2',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData301 = {
  tokenUrl: '9388a29c-46f8-39b0-8c00-83524f642812',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData301 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData301 = [
  {
    id: 1,
    name: 'Nantucket Chair 2',
    thumb: dummy,
  },
]

export const sceneData301 = [
  {
    id: 19651,
    name: 'Nantucket Chair 2',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData1 = {
  tokenUrl: 'd4668d4e-d1a0-3b21-8044-c3a3c0ba4cd6',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData1 = [
  {
    id: 1,
    name: 'pillow',
    thumb: dummy,
  },
]

export const layoutData1 = [
  {
    id: 1,
    name: 'Signature cord welt pillow',
    thumb: dummy,
  },
]

export const sceneData1 = [
  {
    id: 24922,
    name: 'Signature cord welt pillow',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData302 = {
  tokenUrl: '630860b4-9fec-314c-a403-b7ddca2ed66a',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData302 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData302 = [
  {
    id: 1,
    name: 'Beatrix Chair',
    thumb: dummy,
  },
]

export const sceneData302 = [
  {
    id: 24913,
    name: 'Beatrix Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData303 = {
  tokenUrl: '08e28b30-257e-357e-b105-fc007e13a158',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData303 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData303 = [
  {
    id: 1,
    name: 'Sophie chair',
    thumb: dummy,
  },
]

export const sceneData303 = [
  {
    id: 24914,
    name: 'Sophie chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData304 = {
  tokenUrl: '65642f4b-3f3b-3504-a0db-98087bec54b7',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData304 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData304 = [
  {
    id: 1,
    name: 'Stevie chair',
    thumb: dummy,
  },
]

export const sceneData304 = [
  {
    id: 19836,
    name: 'Stevie chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData305 = {
  tokenUrl: '89753c30-42cd-34fe-83e7-fde44ace4386',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData305 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData305 = [
  {
    id: 1,
    name: 'Stevie Ottomon',
    thumb: dummy,
  },
]

export const sceneData305 = [
  {
    id: 19837,
    name: 'Stevie Ottomon',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData306 = {
  tokenUrl: '46548ad3-406c-3aa7-ab50-7c210c82c32b',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData306 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData306 = [
  {
    id: 1,
    name: 'Tessa Chair',
    thumb: dummy,
  },
]

export const sceneData306 = [
  {
    id: 24917,
    name: 'Tessa Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData307 = {
  tokenUrl: '5bd0b334-4c92-3ee9-b55f-814776acb011',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData307 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData307 = [
  {
    id: 1,
    name: 'Vera Chair Plus Swivel',
    thumb: dummy,
  },
]

export const sceneData307 = [
  {
    id: 24918,
    name: 'Vera Chair Plus Swivel',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]
//////////////////////////////
export const configuratorData308 = {
  tokenUrl: 'be8d482f-5882-3886-9ada-09b578eec8e0',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData308 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData308 = [
  {
    id: 1,
    name: 'Vera Ottomon',
    thumb: dummy,
  },
]

export const sceneData308 = [
  {
    id: 24919,
    name: 'Vera Ottomon',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData309 = {
  tokenUrl: '3ab171df-503c-3184-b718-79f6aaa1bd96',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData309 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData309 = [
  {
    id: 1,
    name: 'Vera Sofa',
    thumb: dummy,
  },
]

export const sceneData309 = [
  {
    id: 24546,
    name: 'Vera Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData310 = {
  tokenUrl: '6e45809c-b89d-3913-a60f-0de66c5363c6',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData310 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData310 = [
  {
    id: 1,
    name: 'Left Arm Corner Sectional',
    thumb: dummy,
  },
   {
    id: 2,
    name: 'Right Arm Corner Sectional',
    thumb: dummy,
  },
]

export const sceneData310 = [
  {
    id: 24547,
    name: 'Vera Sectional Left',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24561,
    name: 'Vera Sectional Right',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  }
]
//////////////////////////////
export const configuratorData2 = {
  tokenUrl: '104d531e-c593-32b3-8a09-03ca396614f3',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData2 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData2 = [
  {
    id: 1,
    name: 'Signature kidney pillow',
    thumb: dummy,
  },
]

export const sceneData2 = [
  {
    id: 24923,
    name: 'Signature kidney pillow',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData115 = {
  tokenUrl: '2fb8d5d1-c43c-34dd-aef9-373f2b419362',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData115 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData115 = [
  {
    id: 2,
    name: 'No Cushion',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Cokie Barstool - Painted',
    thumb: dummy,
  },
]

export const sceneData115 = [
  {
    id: 24929,
    name: 'Cokie Barstool - Painted - With Pillow',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
   {
    id: 24930,
    name: 'Cokie Barstool - Painted - Without Pillow',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData117 = {
  tokenUrl: '95acd0ff-aaf8-372e-82d6-decc15668b66',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData117 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData117 = [
  {
    id: 1,
    name: 'No Cushion',
    thumb: dummy,
  },
   {
    id: 2,
    name: 'Cokie Counter Stool',
    thumb: dummy,
  },
]

export const sceneData117 = [
  {
    id: 24928,
    name: 'Cokie Counter Stool - Painted - Without Pillow',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
    {
    id: 24875,
    name: 'Cokie Counter Stool - Painted - With Pillow',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData169 = {
  tokenUrl: '73c130b1-0dff-320c-abd5-b3f6cba6d8c7',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData169 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData169 = [
  {
    id: 1,
    name: 'Big Cay Desk with Library Hutch',
    thumb: dummy,
  },
]

export const sceneData169 = [
  {
    id: 20204,
    name: 'Big Cay Desk with Library Hutch',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData311 = {
  tokenUrl: 'b4f8f323-6867-3e7d-af05-147613931bc8',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData311 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData311 = [
  {
    id: 1,
    name: 'Amanda Long Sofa With Skirt',
    thumb: dummy,
  },
]

export const sceneData311 = [
  {
    id: 24548,
    name: 'Amanda Long Sofa With Skirt',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData313 = {
  tokenUrl: 'b4eef5ad-2677-39ca-bf89-cd5e42c044bb',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData313 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData313 = [
  {
    id: 1,
    name: 'Amanda Sofa With Skirt',
    thumb: dummy,
  },
]

export const sceneData313 = [
  {
    id: 24549,
    name: 'Amanda Sofa With Skirt',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData312 = {
  tokenUrl: 'a9497a86-8a76-3b8a-9f11-4408d82126c4',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData312 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData312 = [
  {
    id: 1,
    name: 'Amanda Long Sofa',
    thumb: dummy,
  },
]

export const sceneData312 = [
  {
    id: 24814,
    name: 'Amanda Long Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData314 = {
  tokenUrl: '3a856f2a-c527-30f6-82a4-15df512a1983',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData314 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData314 = [
  {
    id: 1,
    name: 'Amanda Sofa',
    thumb: dummy,
  },
]

export const sceneData314 = [
  {
    id: 24550,
    name: 'Amanda Sofa',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData315 = {
  tokenUrl: '975e0654-bb48-3dee-b357-c53420f91ca9',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData315 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData315 = [
  {
    id: 1,
    name: 'Alice Chair Skirtless',
    thumb: dummy,
  },
]

export const sceneData315 = [
  {
    id: 24933,
    name: 'Alice Chair Skirtless',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData316 = {
  tokenUrl: 'fa43e121-4e5d-3a9d-ba19-e5c21c629f44',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData316 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData316 = [
  {
    id: 1,
    name: 'Alice Ottoman Skirtless',
    thumb: dummy,
  },
]

export const sceneData316 = [
  {
    id: 24936,
    name: 'Alice Ottoman Skirtless',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData319 = {
  tokenUrl: '0a4e76cf-15a0-3e71-9f05-e8c9dd449387',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData319 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData319 = [
  {
    id: 1,
    name: 'Alice Skirted Chair',
    thumb: dummy,
  },
]

export const sceneData319 = [
  {
    id: 24935,
    name: 'Alice Skirted Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData320 = {
  tokenUrl: 'b2a2c6a3-9b00-3b06-996a-aed8fe8e54ad',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData320 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData320 = [
  {
    id: 1,
    name: 'Alice Ottoman Skirted',
    thumb: dummy,
  },
]

export const sceneData320 = [
  {
    id: 24934,
    name: 'Alice Ottoman Skirted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData321 = {
  tokenUrl: '95348aed-d92f-3bce-8941-86c9e0f0dccb',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData321 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData321 = [
  {
    id: 1,
    name: 'Cecilia Long Sofa 96',
    thumb: dummy,
  },
]

export const sceneData321 = [
  {
    id: 24942,
    name: 'Cecilia Long Sofa 96',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData323 = {
  tokenUrl: 'f5a7f1d9-a8e0-38ef-b1c0-09a64dbf6901',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData323 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData323 = [
  {
    id: 1,
    name: 'Cody Extra Long Sofa 107',
    thumb: dummy,
  },
]

export const sceneData323 = [
  {
    id: 24551,
    name: 'Cody Extra Long Sofa 107',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData325 = {
  tokenUrl: '386d9b7a-3812-360f-9da9-e20cfe318b63',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData325 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData325 = [
  {
    id: 1,
    name: 'Cody Long Sofa 95',
    thumb: dummy,
  },
]

export const sceneData325 = [
  {
    id: 24552,
    name: 'Cody Long Sofa 95',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData327 = {
  tokenUrl: 'aaf21a17-b790-3adb-879a-8a48bcb73d95',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData327 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData327 = [
  {
    id: 1,
    name: 'Cody Sofa 83',
    thumb: dummy,
  },
]

export const sceneData327 = [
  {
    id: 24553,
    name: 'Cody Sofa 83',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData330 = {
  tokenUrl: '56a43dff-c778-3fbb-a97f-b0850b6030e6',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData330 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData330 = [
  {
    id: 1,
    name: 'Tessa Ottoman',
    thumb: dummy,
  },
]

export const sceneData330 = [
  {
    id: 24939,
    name: 'Tessa Ottoman',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData331 = {
  tokenUrl: 'fda2a754-6205-3733-a856-bbffc3cb7f71',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData331 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData331 = [
  {
    id: 1,
    name: 'Vera Apartment Sofa 76.5',
    thumb: dummy,
  },
]

export const sceneData331 = [
  {
    id: 24940,
    name: 'Vera Apartment Sofa 76.5',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData317 = {
  tokenUrl: '7ebbd3d7-2a4e-33b6-b9eb-79c8def1926b',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: false,
}

export const profileData317 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData317 = [
  {
    id: 1,
    name: 'Left Arm Corner Sectional',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Right Arm Corner Sectional',
    thumb: dummy,
  },
]

export const sceneData317 = [
  {
    id: 24943,
    name: 'Alice Sectional Skirted Left Arm',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24944,
    name: 'Alice Sectional Skirted Right Arm',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData318 = {
  tokenUrl: 'd4646488-7cab-31a6-a3f3-598ec0f8e718',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData318 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData318 = [
  {
    id: 1,
    name: 'Left Arm Corner Sectional',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Right Arm Corner Sectional',
    thumb: dummy,
  }
]

export const sceneData318 = [
  {
    id: 24946,
    name: 'Alice Sectional Skirtless Right Arm',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24945,
    name: 'Alice Sectional Skirtless Left Arm',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData322 = {
  tokenUrl: '93facc54-b435-30cb-b06b-eae10fa71769',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData322 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData322 = [
  {
    id: 2,
    name: 'Left Arm Corner Sectional',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'Right Arm Corner Sectional',
    thumb: dummy,
  }
]

export const sceneData322 = [
  {
    id: 24554,
    name: 'Cody Classic Sectional Left',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24559,
    name: 'Cody Classic Sectional Right',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]


//////////////////////////////
export const configuratorData328 = {
  tokenUrl: '2bf08d16-179e-3170-8251-def94691da11',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData328 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData328 = [
  {
    id: 1,
    name: 'Chaise on Left',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Chaise on Right',
    thumb: dummy,
  }
]

export const sceneData328 = [
  {
    id: 24555,
    name: 'Cody Wrap Around Sectional Left',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24560,
    name: 'Cody Wrap Around Sectional Right',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData326 = {
  tokenUrl: 'b277c469-a5df-3fd0-b5e1-ab76fbd418e9',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData326 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData326 = [
  {
    id: 1,
    name: 'Cody Loveseat 58',
    thumb: dummy,
  },
]

export const sceneData326 = [
  {
    id: 24950,
    name: 'Cody Loveseat 58',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData324 = {
  tokenUrl: '23821c37-6752-3c03-b145-d372c43cf531',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData324 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData324 = [
  {
    id: 1,
    name: 'Chaise on Left',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Chaise on Right',
    thumb: dummy,
  }
]

export const sceneData324 = [
  {
    id: 24556,
    name: 'Cody Long Chaise Sectional',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
   {
    id: 24557,
    name: 'Cody Long Chaise Sectional_Right',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  }
]


//////////////////////////////
export const configuratorData329 = {
  tokenUrl: 'e59b3930-4529-3315-8c8a-a597948c32fa',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData329 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData329 = [
  {
    id: 1,
    name: 'Colby Ottoman',
    thumb: dummy,
  },
]

export const sceneData329 = [
  {
    id: 24952,
    name: 'Colby Ottoman',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData332 = {
  tokenUrl: '1a091117-850f-3cd3-8bcc-66b4209e6692',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData332 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData332 = [
  {
    id: 1,
    name: 'Vera Long Sofa 94.5',
    thumb: dummy,
  },
]

export const sceneData332 = [
  {
    id: 24815,
    name: 'Vera Long Sofa 94.5',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData333 = {
  tokenUrl: '764f7f25-c720-3189-806b-4a9f47b16c1b',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData333 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData333 = [
  {
    id: 1,
    name: 'Grace Dining Chair',
    thumb: dummy,
  },
]

export const sceneData333 = [
  {
    id: 24957,
    name: 'Grace Dining Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData334 = {
  tokenUrl: '69396f66-fc39-3d11-b817-a95a7a671d43',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData334 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData334 = [
  {
    id: 1,
    name: 'Dolly Dining Chair',
    thumb: dummy,
  },
]

export const sceneData334 = [
  {
    id: 24958,
    name: 'Dolly Dining Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData335 = {
  tokenUrl: '7be19e5a-3b7e-3cda-89fb-266c280d8805',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData335 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData335 = [
  {
    id: 1,
    name: 'Shelfie Coffee Table Small',
    thumb: dummy,
  },
]

export const sceneData335 = [
  {
    id: 23444,
    name: 'Shelfie Coffee Table Small',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData336 = {
  tokenUrl: 'e965f8a9-43cb-361f-a2de-c0ae45e8ce45',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData336 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData336 = [
  {
    id: 1,
    name: '42',
    thumb: dummy,
  },
  {
    id: 2,
    name: '48',
    thumb: dummy,
  },
  {
    id: 3,
    name: '54',
    thumb: dummy,
  },
  {
    id: 4,
    name: '60',
    thumb: dummy,
  },
]

export const sceneData336 = [
  {
    id: 24011,
    name: 'Marriner Table 42',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 23993,
    name: 'Marriner Table 48',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 23441,
    name: 'Marriner Table 54',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 23992,
    name: 'Marriner Table 60',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData337 = {
  tokenUrl: 'e965f8a9-43cb-361f-a2de-c0ae45e8ce45',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData337 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData337 = [
  {
    id: 1,
    name: '42',
    name_shopify: '42" - Seats 2',
    thumb: dummy,
  },
  {
    id: 2,
    name: '48',
    name_shopify: '48" - Seats 4',
    thumb: dummy,
  },
  {
    id: 3,
    name: '54',
    name_shopify: '54" - Seats 5',
    thumb: dummy,
  },
  {
    id: 4,
    name: '60',
    name_shopify: '60" - Seats 6',
    thumb: dummy,
  },
]

export const sceneData337 = [
  {
    id: 24011,
    name: 'Marriner Table 42',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 23993,
    name: 'Marriner Table 48',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 23441,
    name: 'Marriner Table 54',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 23992,
    name: 'Marriner Table 60',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData85 = {
  tokenUrl: '43893b06-ee79-39ec-a3ab-7d99a1fab1c1',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData85 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData85 = [
  {
    id: 2,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'King',
    thumb: dummy,
  },
  {
    id: 3,
    name: 'Double',
    thumb: dummy,
  },
  {
    id: 4,
    name: 'Queen',
    thumb: dummy,
  }
]

export const sceneData85 = [
  {
    id: 24407,
    name: 'High Tide Bed King',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24408,
    name: 'High Tide Bed Twin',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24409,
    name: 'High Tide Bed Double',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24410,
    name: 'High Tide Bed Queen',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]

//////////////////////////////
export const configuratorData87 = {
  tokenUrl: 'a9146841-ab39-3179-8977-10662e43edca',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData87 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData87 = [
  {
    id: 2,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'King',
    thumb: dummy,
  },
  {
    id: 3,
    name: 'Double',
    thumb: dummy,
  },
  {
    id: 4,
    name: 'Queen',
    thumb: dummy,
  }
]

export const sceneData87 = [
  {
    id: 24411,
    name: 'King',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24414,
    name: 'Twin',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24412,
    name: 'Double',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24413,
    name: 'Queen',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]

//////////////////////////////
export const configuratorData93 = {
  tokenUrl: '454c429f-bb0a-3107-bd42-6f4520e7f48b',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData93 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData93 = [
  
  {
    id: 2,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'King',
    thumb: dummy,
  },
  {
    id: 3,
    name: 'Double',
    thumb: dummy,
  },
  {
    id: 4,
    name: 'Queen',
    thumb: dummy,
  }
]

export const sceneData93 = [
  {
    id: 24415,
    name: 'Shutter Bed King',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24417,
    name: 'Shutter Bed Twin',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24418,
    name: 'Shutter Bed Double',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24416,
    name: 'Shutter Bed Queen',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]


//////////////////////////////
export const configuratorData223 = {
  tokenUrl: '5a1fbc48-2087-363c-b67b-4b963893ea7d',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData223 = [
  {
    id: 1,
    name: 'Lattice Bed',
    thumb: dummy,
  },
]

export const layoutData223 = [
  
  {
    id: 2,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'King',
    thumb: dummy,
  },
  {
    id: 3,
    name: 'Double',
    thumb: dummy,
  },
  {
    id: 4,
    name: 'Queen',
    thumb: dummy,
  }
]

export const sceneData223 = [
  {
    id: 24406,
    name: 'Lattice Bed King',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24403,
    name: 'Lattice Bed Twin',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24404,
    name: 'Lattice Bed Double',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24405,
    name: 'Lattice Bed Queen',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]

//////////////////////////////
export const configuratorData90 = {
  tokenUrl: 'e34925a8-0037-38dd-b53e-e479a9976f23',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData90 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData90 = [
  {
    id: 2,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'King',
    thumb: dummy,
  },
  
  {
    id: 3,
    name: 'Double',
    thumb: dummy,
  },
  {
    id: 4,
    name: 'Queen',
    thumb: dummy,
  }
]

export const sceneData90 = [
  {
    id: 24420,
    name: 'Mabel Bed King',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24422,
    name: 'Mabel Bed Twin',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24419,
    name: 'Mabel Bed Double',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24421,
    name: 'Mabel Bed Queen',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]
//////////////////////////////
export const configuratorData81 = {
  tokenUrl: '5f255021-fe66-3414-924d-ea83e30359e5',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData81 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData81 = [
  {
    id: 3,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'King',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Queen',
    thumb: dummy,
  },
]

export const sceneData81 = [
  {
    id: 24476,
    name: 'Annie Bed King',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24477,
    name: 'Annie Bed Queen',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24478,
    name: 'Annie Bed Twin',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData84 = {
  tokenUrl: '39d5f2fb-0757-38c2-b7e0-96e3e87a09c4',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData84 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData84 = [
  {
    id: 4,
    name: 'Twin',
    thumb: dummy,
  },
  {
    id: 1,
    name: 'King',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 3,
    name: 'Double',
    thumb: dummy,
  }
]

export const sceneData84 = [
  {
    id: 24373,
    name: 'Eliza Cannonball Bed With Storage King',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24374,
    name: 'Eliza Cannonball Bed With Storage Queen',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24375,
    name: 'Eliza Cannonball Bed With Storage Double',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24376,
    name: 'Eliza Cannonball Bed With Storage Twin',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]


//////////////////////////////
export const configuratorData338 = {
  tokenUrl: 'e5afe268-b8fc-35bd-8beb-330cfd8598c3',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData338 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData338 = [
  {
    id: 1,
    name: '60',
    thumb: dummy,
  },
  {
    id: 2,
    name: '72',
    thumb: dummy,
  },
  {
    id: 3,
    name: '84',
    thumb: dummy,
  },
  {
    id: 4,
    name: '96',
    thumb: dummy,
  }
]

export const sceneData338 = [
  {
    id: 23809,
    name: 'Dottie Bench-60',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 23808,
    name: 'Dottie Bench-72',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 23807,
    name: 'Dottie Bench-84',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 23806,
    name: 'Dottie Bench-96',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]



//////////////////////////////
export const configuratorData339 = {
  tokenUrl: '57babdf8-2a9d-334e-bba5-ebf62f842b07',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData339 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData339 = [
  {
    id: 1,
    name: 'Shelfie Side Table',
    thumb: dummy,
  },
]

export const sceneData339 = [
  {
    id: 23811,
    name: 'Shelfie Side Table',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData340 = {
  tokenUrl: '98e53326-e741-3070-b867-adbebe64f7a6',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData340 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData340 = [
  {
    id: 1,
    name: 'Shelfie Drink Drop Table',
    thumb: dummy,
  },
]

export const sceneData340 = [
  {
    id: 23812,
    name: 'Shelfie Drink Drop Table',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData341 = {
  tokenUrl: '4033db67-ceb1-3191-9710-1ed6cb5268ff',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData341 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData341 = [
  {
    id: 1,
    name: '36',
    thumb: dummy,
  },
  {
    id: 2,
    name: '48',
    thumb: dummy,
  },
  {
    id: 3,
    name: '60',
    thumb: dummy,
  },
  {
    id: 4,
    name: '72',
    thumb: dummy,
  }
]

export const sceneData341 = [
  {
    id: 23816,
    name: 'Shelfie Console Table - 36 inch',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 23815,
    name: 'Shelfie Console Table - 48 inch',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 23814,
    name: 'Shelfie Console Table - 60 inch',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 23813,
    name: 'Shelfie Console Table - 72 inch',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]


//////////////////////////////
export const configuratorData342 = {
  tokenUrl: '3c349533-1d3b-3d70-9cbc-c4faad088779',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData342 = [
  {
    id: 1,
    name: 'Shelfie Large Coffee Table',
    thumb: dummy,
  },
]

export const layoutData342 = [
  {
    id: 1,
    name: 'Shelfie Large Coffee Table',
    thumb: dummy,
  },
]

export const sceneData342 = [
  {
    id: 23817,
    name: 'Shelfie Large Coffee Table',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData343 = {
  tokenUrl: 'ff64fb78-b98b-3093-bb45-d14cf0b9053a',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData343 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData343 = [
  {
    id: 1,
    name: '42',
    name_shopify: '42" - Seats 2',
    thumb: dummy,
  },
  {
    id: 2,
    name: '48',
    name_shopify: '48" - Seats 4',
    thumb: dummy,
  },
  {
    id: 3,
    name: '60',
    name_shopify: '60" - Seats 6',
    thumb: dummy,
  },
  {
    id: 4,
    name: '66',
    name_shopify: '66" - Seats 8',
    thumb: dummy,
  },
  {
    id: 5,
    name: '54',
    name_shopify: '54" - Seats 5',
    thumb: dummy,
  },
]

export const sceneData343 = [
  {
    id: 23820,
    name: 'Ina Dining Table -42 inch',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 23819,
    name: 'Ina Dining Table -48 inch',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 23818,
    name: 'Ina Dining Table -60 inch',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 23861,
    name: 'Ina Dining Table -66 inch',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  },
  {
    id: 23986,
    name: 'Ina Dining Table -54 inch',
    profileId: 1,
    layoutId: 5,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData344 = {
  tokenUrl: 'f4bfa6af-0a52-3dc8-ae57-5c9a4e0effca',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData344 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData344 = [
  {
    id: 1,
    name: '60',
    name_shopify: '60" - Seats 4',
    thumb: dummy,
  },
  {
    id: 2,
    name: '72',
    name_shopify: '72" - Seats 6',
    thumb: dummy,
  },
  {
    id: 3,
    name: '84',
    name_shopify: '84" - Seats 8',
    thumb: dummy,
  },
  {
    id: 4,
    name: '96',
    name_shopify: '96" - Seats 10',
    thumb: dummy,
  },
  
  {
    id: 5,
    name: '108',
    name_shopify: '108" - Seats 12',
    thumb: dummy,
  }
]

export const sceneData344 = [
  {
    id: 23442,
    name: 'Marriner Table 60 inch',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 23824,
    name: 'Marriner Table 72 inch',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 23823,
    name: 'Marriner Table 84 inch',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 23822,
    name: 'Marriner Table 96 inch',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  },
  
  {
    id: 23821,
    name: 'Marriner Table 108 inch',
    profileId: 1,
    layoutId: 5,
    thumb: dummy,
  }
]



//////////////////////////////
export const configuratorData345 = {
  tokenUrl: 'e0d96fa9-745c-3808-b6fd-af782880676d',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData345 = [
  {
    id: 1,
    name: 'Marriner 22inch Round End Table',
    thumb: dummy,
  },
]

export const layoutData345 = [
  {
    id: 1,
    name: 'Marriner 22inch Round End Table',
    thumb: dummy,
  },
]

export const sceneData345 = [
  {
    id: 23832,
    name: 'Marriner 22inch Round End Table',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData346 = {
  tokenUrl: '95d24cb9-5c9b-30be-adb0-e76029ce206b',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData346 = [
  {
    id: 1,
    name: 'Marriner 18inch Round End Table',
    thumb: dummy,
  },
]

export const layoutData346 = [
  {
    id: 1,
    name: 'Marriner 18inch Round End Table',
    thumb: dummy,
  },
]

export const sceneData346 = [
  {
    id: 23833,
    name: 'Marriner 18inch Round End Table',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData347 = {
  tokenUrl: '3ab4d741-7d00-3591-9139-aa7f3ab1d8cf',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData347 = [
  {
    id: 1,
    name: 'Marriner 60inch Sofa Table',
    thumb: dummy,
  },
]

export const layoutData347 = [
  {
    id: 1,
    name: 'Marriner 60inch Sofa Table',
    thumb: dummy,
  },
]

export const sceneData347 = [
  {
    id: 23825,
    name: 'Marriner 60inch Sofa Table',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData348 = {
  tokenUrl: 'b90a5391-49ce-35d9-991f-24010184b559',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData348 = [
  {
    id: 1,
    name: 'Marriner 54inch Sofa Table',
    thumb: dummy,
  },
]

export const layoutData348 = [
  {
    id: 1,
    name: 'Marriner 54inch Sofa Table',
    thumb: dummy,
  },
]

export const sceneData348 = [
  {
    id: 23835,
    name: 'Marriner 54inch Sofa Table',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData349 = {
  tokenUrl: 'ff574842-726f-3498-8f1c-d2e8b0127e9f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData349 = [
  {
    id: 1,
    name: 'Maggie Double Dresser',
    thumb: dummy,
  },
]

export const layoutData349 = [
  {
    id: 1,
    name: 'Maggie Double Dresser',
    thumb: dummy,
  },
]

export const sceneData349 = [
  {
    id: 23826,
    name: 'Maggie Double Dresser',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData350 = {
  tokenUrl: 'cdff5563-04b1-387c-9f25-1d94d8f2b813',
  id: 1,
  name: 'Maine Cottage',
  arViewer: false,
  measureTool: true,
}

export const profileData350 = [
  {
    id: 1,
    name: 'Maggie Tall Dresser',
    thumb: dummy,
  },
]

export const layoutData350 = [
  {
    id: 1,
    name: 'Maggie Tall Dresser',
    thumb: dummy,
  },
]

export const sceneData350 = [
  {
    id: 23827,
    name: 'Maggie Tall Dresser',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData351 = {
  tokenUrl: '23f3dc7f-d465-31bc-86d3-77217b26fc64',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData351 = [
  {
    id: 1,
    name: 'Maggie Bedside Dresser',
    thumb: dummy,
  },
]

export const layoutData351 = [
  {
    id: 1,
    name: 'Maggie Bedside Dresser',
    thumb: dummy,
  },
]

export const sceneData351 = [
  {
    id: 23828,
    name: 'Maggie Bedside Dresser',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData352 = {
  tokenUrl: 'f9664758-5b63-3b13-bb64-3ca17b14f4c3',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData352 = [
  {
    id: 1,
    name: 'Dolly Upholstered Chair',
    thumb: dummy,
  },
]

export const layoutData352 = [
  {
    id: 1,
    name: 'Dolly Upholstered Chair',
    thumb: dummy,
  },
]

export const sceneData352 = [
  {
    id: 24966,
    name: 'Dolly Upholstered Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData353 = {
  tokenUrl: 'd8979e5b-af9c-3817-b018-016bbfbafabf',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData353 = [
  {
    id: 1,
    name: 'Mary Ann Chair',
    thumb: dummy,
  },
]

export const layoutData353 = [
  {
    id: 1,
    name: 'Mary Ann Chair',
    thumb: dummy,
  },
]

export const sceneData353 = [
  {
    id: 24995,
    name: 'Mary Ann Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData354 = {
  tokenUrl: '4145f4fa-f56b-36f6-ade8-563b5704cd38',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData354 = [
  {
    id: 1,
    name: 'Ginger Chair',
    thumb: dummy,
  },
]

export const layoutData354 = [
  {
    id: 1,
    name: 'Ginger Chair',
    thumb: dummy,
  },
]

export const sceneData354 = [
  {
    id: 24989,
    name: 'Ginger Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData355 = {
  tokenUrl: 'b0735270-a363-3a31-99bf-d65bb2819326',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData355 = [
  {
    id: 1,
    name: 'Bancroft Captains Chair',
    thumb: dummy,
  },
]

export const layoutData355 = [
  {
    id: 1,
    name: 'Bancroft Captains Chair',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Bancroft Captains Chair with Cushion',
    thumb: dummy,
  },
]

export const sceneData355 = [
  {
    id: 24970,
    name: 'Bancroft Captains Chair',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24969,
    name: 'Bancroft Captains Chair with Cushion',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData369 = {
  tokenUrl: '50ee0abb-902a-3fcd-ae17-a8066eb64fb3',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData369 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData369 = [
  {
    id: 1,
    name: 'Grace Dining Chair',
    thumb: dummy,
  },
]

export const sceneData369 = [
  {
    id: 24986,
    name: 'Grace Dining Chair Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData370 = {
  tokenUrl: '764f7f25-c720-3189-806b-4a9f47b16c1b',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData370 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData370 = [
  {
    id: 1,
    name: 'Grace Dining Chair',
    thumb: dummy,
  },
]

export const sceneData370 = [
  {
    id: 24957,
    name: 'Grace Dining Chair Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData371 = {
  tokenUrl: '1baae32d-cbdb-3a6e-a98a-c10f7921f5c9',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData371 = [
  {
    id: 1,
    name: 'Chair',
    thumb: dummy,
  },
]

export const layoutData371 = [
  {
    id: 1,
    name: 'Dolly Dining Chair',
    thumb: dummy,
  },
]

export const sceneData371 = [
  {
    id: 24987,
    name: 'Dolly Upholstered Chair Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData372 = {
  tokenUrl: 'f9664758-5b63-3b13-bb64-3ca17b14f4c3',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData372 = [
  {
    id: 1,
    name: 'Dolly Upholstered Chair Wood',
    thumb: dummy,
  },
]

export const layoutData372 = [
  {
    id: 1,
    name: 'Dolly Dining Chair',
    thumb: dummy,
  },
]

export const sceneData372 = [
  {
    id: 24966,
    name: 'Dolly Upholstered Chair Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData373 = {
  tokenUrl: '30c507c8-a952-3112-8e00-0e1571312635',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData373 = [
  {
    id: 1,
    name: 'Dolly Upholstered Bar Stool',
    thumb: dummy,
  },
]

export const layoutData373 = [
  {
    id: 1,
    name: 'Dolly Upholstered Bar Stool',
    thumb: dummy,
  },
]

export const sceneData373 = [
  {
    id: 24973,
    name: 'Dolly Upholstered Bar Stool Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData374 = {
  tokenUrl: '3c9fcefb-d288-3eb0-b89d-6311f58350c8',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData374 = [
  {
    id: 1,
    name: 'Dolly Upholstered Counter Stool_Wood',
    thumb: dummy,
  },
]

export const layoutData374 = [
  {
    id: 1,
    name: 'Dolly Upholstered Counter Stool',
    thumb: dummy,
  },
]

export const sceneData374 = [
  {
    id: 24981,
    name: 'Dolly Upholstered Counter Stool_Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData381 = {
  tokenUrl: '29a88260-27b2-34a8-b379-0f7c449b68a3',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData381 = [
  {
    id: 1,
    name: 'Maggie Double Dresser Painted',
    thumb: dummy,
  },
]

export const layoutData381 = [
  {
    id: 1,
    name: 'Maggie Double Dresser',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Wood Knobs',
    thumb: dummy,
  },
]

export const sceneData381 = [
  {
    id: 23826,
    name: 'Maggie Double Dresser Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24028,
    name: 'Maggie Double Dresser Wood Knobs Painted',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData382 = {
  tokenUrl: '86f359b6-7390-3d4b-b914-ead175c1ecb4',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData382 = [
  {
    id: 1,
    name: 'Maggie Double Dresser Wood',
    thumb: dummy,
  },
]

export const layoutData382 = [
  {
    id: 1,
    name: 'Maggie Double Dresser',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Wood Knobs',
    thumb: dummy,
  },
]

export const sceneData382 = [
  {
    id: 23906,
    name: 'Maggie Double Dresser Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24027,
    name: 'Maggie Double Dresser Wood Knobs',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData383 = {
  tokenUrl: '23dba294-ce50-3259-925f-53408437c69b',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData383 = [
  {
    id: 1,
    name: 'Maggie Tall Dresser Painted',
    thumb: dummy,
  },
]

export const layoutData383 = [
  {
    id: 1,
    name: 'Maggie Tall Dresser',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Wood Knobs',
    thumb: dummy,
  },
]

export const sceneData383 = [
  {
    id: 23827,
    name: 'Maggie Tall Dresser Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24021,
    name: 'Maggie Tall Dresser Wood Knobs Painted',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData384 = {
  tokenUrl: 'e19490b8-c917-380f-9545-1363988a5ad7',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData384 = [
  {
    id: 1,
    name: 'Maggie Tall Dresser Wood',
    thumb: dummy,
  },
]

export const layoutData384 = [
  {
    id: 1,
    name: 'Maggie Tall Dresser',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Wood Knobs',
    thumb: dummy,
  },
]

export const sceneData384 = [
  {
    id: 23911,
    name: 'Maggie Tall Dresser Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24024,
    name: 'Maggie Tall Dresser Wood Knobs Wood',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData385 = {
  tokenUrl: 'cd706443-0170-3a57-9eab-c8b5711430d7',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData385 = [
  {
    id: 1,
    name: 'Maggie Bedside Dresser Painted',
    thumb: dummy,
  },
]

export const layoutData385 = [
  {
    id: 1,
    name: 'Maggie Bedside Dresser',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Wood Knobs',
    thumb: dummy,
  },
]

export const sceneData385 = [
  {
    id: 23828,
    name: 'Maggie Bedside Dresser Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24022,
    name: 'Maggie Bedside Dresser Wood Knobs Painted',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData386 = {
  tokenUrl: '62821d26-a3c1-3b2c-83b7-337e6005a75a',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData386 = [
  {
    id: 1,
    name: 'Maggie Bedside Dresser Wood',
    thumb: dummy,
  },
]

export const layoutData386 = [
  {
    id: 1,
    name: 'Maggie Bedside Dresser',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Wood Knobs',
    thumb: dummy,
  },
]

export const sceneData386 = [
  {
    id: 23912,
    name: 'Maggie Bedside Dresser Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24023,
    name: 'Maggie Bedside Dresser Wood Knobs Wood',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData387 = {
  tokenUrl: '4802c788-69ca-3182-83ba-3f4a6a01b82c',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData387 = [
  {
    id: 1,
    name: 'Shelfie Console Tables 36 Painted',
    thumb: dummy,
  },
]

export const layoutData387 = [
  {
    id: 1,
    name: 'Shelfie Console Tables 36',
    thumb: dummy,
  },
]

export const sceneData387 = [
  {
    id: 23816,
    name: 'Shelfie Console Tables 36 Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData388 = {
  tokenUrl: '8e1cf10e-ba02-3dd6-ba75-0db3c3eeb5b8',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData388 = [
  {
    id: 1,
    name: 'Shelfie Console Tables 36',
    thumb: dummy,
  },
]

export const layoutData388 = [
  {
    id: 1,
    name: 'Shelfie Console Tables 36',
    thumb: dummy,
  },
]

export const sceneData388 = [
  {
    id: 23926,
    name: 'Shelfie Console Tables 36 Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData389 = {
  tokenUrl: '06255deb-f561-3a98-a331-2f5add28498f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData389 = [
  {
    id: 1,
    name: 'Shelfie Console Table-48inch Painted',
    thumb: dummy,
  },
]

export const layoutData389 = [
  {
    id: 1,
    name: 'Shelfie Console Table-48inch',
    thumb: dummy,
  },
]

export const sceneData389 = [
  {
    id: 23815,
    name: 'Shelfie Console Table-48inch Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData390 = {
  tokenUrl: '5a2d0330-ab8d-33f1-8a4b-921bb189d7bf',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData390 = [
  {
    id: 1,
    name: 'Shelfie Console Table-48inch Wood',
    thumb: dummy,
  },
]

export const layoutData390 = [
  {
    id: 1,
    name: 'Shelfie Console Table-48inch',
    thumb: dummy,
  },
]

export const sceneData390 = [
  {
    id: 23925,
    name: 'Shelfie Console Table-48inch Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData391 = {
  tokenUrl: '34cbb014-3e96-3f75-b5af-1af6fdb2e6b1',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData391 = [
  {
    id: 1,
    name: 'Shelfie Console Table-60inch Painted',
    thumb: dummy,
  },
]

export const layoutData391 = [
  {
    id: 1,
    name: 'Shelfie Console Table-60inch',
    thumb: dummy,
  },
]

export const sceneData391 = [
  {
    id: 23814,
    name: 'Shelfie Console Table-60inch Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData392 = {
  tokenUrl: 'cd8e17b6-d5e5-3a76-899c-1c20eb4c4e4a',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData392 = [
  {
    id: 1,
    name: 'Shelfie Console Table-60inch Wood',
    thumb: dummy,
  },
]

export const layoutData392 = [
  {
    id: 1,
    name: 'Shelfie Console Table-60inch',
    thumb: dummy,
  },
]

export const sceneData392 = [
  {
    id: 23924,
    name: 'Shelfie Console Table-60inch Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData393 = {
  tokenUrl: '68e3562a-3f36-3e1f-9a2b-bc3b04b7a771',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData393 = [
  {
    id: 1,
    name: 'Shelfie Console Table - 72inch Painted',
    thumb: dummy,
  },
]

export const layoutData393 = [
  {
    id: 1,
    name: 'Shelfie Console Table - 72inch',
    thumb: dummy,
  },
]

export const sceneData393 = [
  {
    id: 23813,
    name: 'Shelfie Console Table - 72inch Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData394 = {
  tokenUrl: '2c9f6298-166d-30ea-9f61-c6061e7ab747',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData394 = [
  {
    id: 1,
    name: 'Shelfie Console Table - 72inch Wood',
    thumb: dummy,
  },
]

export const layoutData394 = [
  {
    id: 1,
    name: 'Shelfie Console Table - 72inch',
    thumb: dummy,
  },
]

export const sceneData394 = [
  {
    id: 23923,
    name: 'Shelfie Console Table - 72inch Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData395 = {
  tokenUrl: '7be19e5a-3b7e-3cda-89fb-266c280d8805',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData395 = [
  {
    id: 1,
    name: 'Shelfie Coffee Table Small Painted',
    thumb: dummy,
  },
]

export const layoutData395 = [
  {
    id: 1,
    name: 'Shelfie Coffee Table Small',
    thumb: dummy,
  },
]

export const sceneData395 = [
  {
    id: 23444,
    name: 'Shelfie Coffee Table Small Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData396 = {
  tokenUrl: '6644edfe-7460-354f-8ce6-bbd908812ea8',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData396 = [
  {
    id: 1,
    name: 'Shelfie Coffee Table Small Wood',
    thumb: dummy,
  },
]

export const layoutData396 = [
  {
    id: 1,
    name: 'Shelfie Coffee Table Small',
    thumb: dummy,
  },
]

export const sceneData396 = [
  {
    id: 23920,
    name: 'Shelfie Coffee Table Small Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData397 = {
  tokenUrl: '3c349533-1d3b-3d70-9cbc-c4faad088779',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData397 = [
  {
    id: 1,
    name: 'Shelfie Large Coffee Table Painted',
    thumb: dummy,
  },
]

export const layoutData397 = [
  {
    id: 1,
    name: 'Shelfie Large Coffee Table',
    thumb: dummy,
  },
]

export const sceneData397 = [
  {
    id: 23817,
    name: 'Shelfie Large Coffee Table Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData398 = {
  tokenUrl: 'bebdd6c6-4122-397d-905b-0b7c869d91c8',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData398 = [
  {
    id: 1,
    name: 'Shelfie Large Coffee Table Wood',
    thumb: dummy,
  },
]

export const layoutData398 = [
  {
    id: 1,
    name: 'Shelfie Large Coffee Table',
    thumb: dummy,
  },
]

export const sceneData398 = [
  {
    id: 23927,
    name: 'Shelfie Large Coffee Table Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData399 = {
  tokenUrl: '57babdf8-2a9d-334e-bba5-ebf62f842b07',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData399 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData399 = [
  {
    id: 1,
    name: 'Shelfie Side Table',
    thumb: dummy,
  },
]

export const sceneData399 = [
  {
    id: 23811,
    name: 'Shelfie Side Table Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData400 = {
  tokenUrl: '32f59f8d-f103-384c-b5ce-2f2048ed7076',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData400 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData400 = [
  {
    id: 1,
    name: 'Shelfie Side Table',
    thumb: dummy,
  },
]

export const sceneData400 = [
  {
    id: 23921,
    name: 'Shelfie Side Table Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData401 = {
  tokenUrl: '98e53326-e741-3070-b867-adbebe64f7a6',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData401 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData401 = [
  {
    id: 1,
    name: 'Shelfie Drink Drop Table',
    thumb: dummy,
  },
]

export const sceneData401 = [
  {
    id: 23812,
    name: 'Shelfie Drink Drop Table Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData402 = {
  tokenUrl: '6f58288d-5976-3d92-ac17-b6e9c5a8a1df',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData402 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData402 = [
  {
    id: 1,
    name: 'Shelfie Drink Drop Table',
    thumb: dummy,
  },
]

export const sceneData402 = [
  {
    id: 23922,
    name: 'Shelfie Drink Drop Table Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData403 = {
  tokenUrl: 'be8171ea-2077-3e33-9e9b-a410958f5f5f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData403 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData403 = [
  {
    id: 1,
    name: '60',
    name_shopify: '60"',
    thumb: dummy,
  },
  {
    id: 2,
    name: '72',
    name_shopify: '72"',
    thumb: dummy,
  },
  {
    id: 3,
    name: '84',
    name_shopify: '84"',
    thumb: dummy,
  },
  {
    id: 4,
    name: '96',
    name_shopify: '96"',
    thumb: dummy,
  }
]

export const sceneData403 = [
  {
    id: 24965,
    name: 'Dottie Bench-60 Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24964,
    name: 'Dottie Bench-72 Painted',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24963,
    name: 'Dottie Bench-84 Painted',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24962,
    name: 'Dottie Bench-96 Painted',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]

export const configuratorData412 = {
  tokenUrl: 'be8171ea-2077-3e33-9e9b-a410958f5f5f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData412 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData412 = [
  {
    id: 1,
    name: '60',
    name_shopify: '60"',
    thumb: dummy,
  }
]

export const sceneData412 = [
  {
    id: 24965,
    name: 'Dottie Bench-60 Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]

export const configuratorData413 = {
  tokenUrl: 'be8171ea-2077-3e33-9e9b-a410958f5f5f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData413 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData413 = [
  {
    id: 1,
    name: '72',
    name_shopify: '72"',
    thumb: dummy,
  }
]

export const sceneData413 = [
  {
    id: 24964,
    name: 'Dottie Bench-72 Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]

export const configuratorData414 = {
  tokenUrl: 'be8171ea-2077-3e33-9e9b-a410958f5f5f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData414 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData414 = [
  {
    id: 1,
    name: '84',
    name_shopify: '84"',
    thumb: dummy,
  }
]

export const sceneData414 = [
  {
    id: 24963,
    name: 'Dottie Bench-84 Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]

export const configuratorData415 = {
  tokenUrl: 'be8171ea-2077-3e33-9e9b-a410958f5f5f',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData415 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData415 = [
  {
    id: 1,
    name: '96',
    name_shopify: '96"',
    thumb: dummy,
  }
]

export const sceneData415 = [
  {
    id: 24962,
    name: 'Dottie Bench-96 Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]

//////////////////////////////
export const configuratorData404 = {
  tokenUrl: '3efaed73-816c-3944-b47c-d4f9ff085089',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData404 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData404 = [
  {
    id: 1,
    name: '60',
    name_shopify: '60"',
    thumb: dummy,
  },
  {
    id: 2,
    name: '72',
    name_shopify: '72"',
    thumb: dummy,
  },
  {
    id: 3,
    name: '84',
    name_shopify: '84"',
    thumb: dummy,
  },
  {
    id: 4,
    name: '96',
    name_shopify: '96"',
    thumb: dummy,
  }
]

export const sceneData404 = [
  {
    id: 24980,
    name: 'Dottie Bench-60 Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24979,
    name: 'Dottie Bench-72 Wood',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
  {
    id: 24978,
    name: 'Dottie Bench-84 Wood',
    profileId: 1,
    layoutId: 3,
    thumb: dummy,
  },
  {
    id: 24977,
    name: 'Dottie Bench-96 Wood',
    profileId: 1,
    layoutId: 4,
    thumb: dummy,
  }
]

export const configuratorData416 = {
  tokenUrl: '3efaed73-816c-3944-b47c-d4f9ff085089',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData416 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData416 = [
  {
    id: 1,
    name: '60',
    name_shopify: '60"',
    thumb: dummy,
  }
]

export const sceneData416 = [
  {
    id: 24980,
    name: 'Dottie Bench-60 Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]

export const configuratorData417 = {
  tokenUrl: '3efaed73-816c-3944-b47c-d4f9ff085089',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData417 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData417 = [
  {
    id: 1,
    name: '72',
    name_shopify: '72"',
    thumb: dummy,
  }
]

export const sceneData417 = [
  {
    id: 24979,
    name: 'Dottie Bench-72 Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]

export const configuratorData418 = {
  tokenUrl: '3efaed73-816c-3944-b47c-d4f9ff085089',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData418 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData418 = [
  {
    id: 1,
    name: '84',
    name_shopify: '84"',
    thumb: dummy,
  }
]

export const sceneData418 = [
  
  {
    id: 24978,
    name: 'Dottie Bench-84 Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]

export const configuratorData419 = {
  tokenUrl: '3efaed73-816c-3944-b47c-d4f9ff085089',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData419 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData419 = [
  {
    id: 1,
    name: '96',
    name_shopify: '96"',
    thumb: dummy,
  }
]

export const sceneData419 = [
  {
    id: 24977,
    name: 'Dottie Bench-96 Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  }
]

//////////////////////////////
export const configuratorData379 = {
  tokenUrl: '175e4731-14ec-3987-afba-1f9223f0c5ce',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData379 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData379 = [
  {
    id: 1,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'King',
    thumb: dummy,
  },

]

export const sceneData379 = [
  {
    id: 24469,
    name: 'Conrad Bed Queen Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24468,
    name: 'Conrad Bed King Painted',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData380 = {
  tokenUrl: '85debdde-a1d2-3cb9-9dff-840cfc2aa458',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData380 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData380 = [
  {
    id: 1,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'King',
    thumb: dummy,
  },

]

export const sceneData380 = [
  {
    id: 24471,
    name: 'Conrad Bed Queen Wooden',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24470,
    name: 'Conrad Bed King Wooden',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData361 = {
  tokenUrl: 'b9606048-9aed-3eed-84c2-30e7996a569c',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData361 = [
  {
    id: 1,
    name: 'Mary Ann Chair with Upholstered Seat Painted',
    thumb: dummy,
  },
]

export const layoutData361 = [
  {
    id: 1,
    name: 'Mary Ann Chair',
    thumb: dummy,
  },
]

export const sceneData361 = [
  {
    id: 24988,
    name: 'Mary Ann Chair with Upholstered Seat Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData362 = {
  tokenUrl: 'c44e3b3e-1f46-3075-bb9d-1e65e583d583',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData362 = [
  {
    id: 1,
    name: 'Mary Ann Chair with Upholstered Seat Wooden',
    thumb: dummy,
  },
]

export const layoutData362 = [
  {
    id: 1,
    name: 'Mary Ann Chair',
    thumb: dummy,
  },
]

export const sceneData362 = [
  {
    id: 24967,
    name: 'Mary Ann Chair with Upholstered Seat Wooden',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData365 = {
  tokenUrl: '4145f4fa-f56b-36f6-ade8-563b5704cd38',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData365 = [
  {
    id: 1,
    name: 'Ginger Chair with Upholstered Seat Painted',
    thumb: dummy,
  },
]

export const layoutData365 = [
  {
    id: 1,
    name: 'Ginger Chair',
    thumb: dummy,
  },
]

export const sceneData365 = [
  {
    id: 24989,
    name: 'Ginger Chair with Upholstered Seat Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData366 = {
  tokenUrl: '9d5c7595-9533-332c-b8cb-47f50a3665a1',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData366 = [
  {
    id: 1,
    name: 'Ginger Chair with Upholstered Seat Wooden',
    thumb: dummy,
  },
]

export const layoutData366 = [
  {
    id: 1,
    name: 'Ginger Chair',
    thumb: dummy,
  },
]

export const sceneData366 = [
  {
    id: 24968,
    name: 'Ginger Chair with Upholstered Seat Wooden',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData377 = {
  tokenUrl: '0c1b413d-6e19-355c-95b2-4087df160bbf',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData377 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData377 = [
  {
    id: 1,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'King',
    thumb: dummy,
  },

]

export const sceneData377 = [
  {
    id: 24473,
    name: 'Frances Bed Queen Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24472,
    name: 'Frances Bed King Painted',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData378 = {
  tokenUrl: '9686bf2f-c868-35d8-9102-62ebd1d9f0a3',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData378 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData378 = [
  {
    id: 1,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'King',
    thumb: dummy,
  },

]

export const sceneData378 = [
  {
    id: 24475,
    name: 'Frances Bed Queen Wooden',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24474,
    name: 'Frances Bed King Wooden',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]



//////////////////////////////
export const configuratorData405 = {
  tokenUrl: 'c3cf97a1-45d0-3de1-ae15-ddce474daab5',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData405 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData405 = [
  {
    id: 1,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'King',
    thumb: dummy,
  },

]

export const sceneData405 = [
  {
    id: 24425,
    name: 'Maggie Bed Queen Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24424,
    name: 'Maggie Bed King Painted',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData406 = {
  tokenUrl: 'c8f58cef-e376-3146-af26-6d897604f5b3',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData406 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData406 = [
  {
    id: 1,
    name: 'Queen',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'King',
    thumb: dummy,
  },

]

export const sceneData406 = [
  {
    id: 24427,
    name: 'Maggie Bed Queen Wooden',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24426,
    name: 'Maggie Bed King Wooden',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData363 = {
  tokenUrl: 'd8979e5b-af9c-3817-b018-016bbfbafabf',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData363 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData363 = [
  {
    id: 1,
    name: 'Mary Ann Chair',
    thumb: dummy,
  },
]

export const sceneData363 = [
  {
    id: 24995,
    name: 'Mary Ann Chair solid wood_painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData364 = {
  tokenUrl: '6d8d51c7-c122-39a1-bba1-b7c4875329bd',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData364 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData364 = [
  {
    id: 1,
    name: 'Mary Ann Chair',
    thumb: dummy,
  },
]

export const sceneData364 = [
  {
    id: 24996,
    name: 'Mary Ann Chair solid wood_wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData367 = {
  tokenUrl: '0f004ab3-7b30-3283-a26f-de0249c4dee8',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData367 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData367 = [
  {
    id: 1,
    name: 'Ginger Chair',
    thumb: dummy,
  },
]

export const sceneData367 = [
  {
    id: 24985,
    name: 'Ginger Chair solid wood_painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData368 = {
  tokenUrl: '807f439c-fcef-3e95-87ed-d0ddf31a750c',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData368 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData368 = [
  {
    id: 1,
    name: 'Ginger Chair',
    thumb: dummy,
  },
]

export const sceneData368 = [
  {
    id: 23997,
    name: 'Ginger Chair solid wood_wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData375 = {
  tokenUrl: 'b33136cb-f0fa-34e5-8d01-96307143d86c',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData375 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData375 = [
  {
    id: 1,
    name: 'Dolly Upholstered Counter Stool',
    thumb: dummy,
  },
]

export const sceneData375 = [
  {
    id: 24974,
    name: 'Dolly Upholstered Counter Stool',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData376 = {
  tokenUrl: '2bd57bf8-b0df-3a11-8c4f-e514fc449a55',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData376 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData376 = [
  {
    id: 1,
    name: 'Dolly Upholstered Bar Stool',
    thumb: dummy,
  },
]

export const sceneData376 = [
  {
    id: 24992,
    name: 'Dolly Upholstered Bar Stool_Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData218 = {
  tokenUrl: '3a344ed9-07b2-398a-a9fa-297564735985',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData218 = [
  {
    id: 1,
    name: 'chair',
    thumb: dummy,
  },
]

export const layoutData218 = [
  {
    id: 1,
    name: 'Trundle Bed',
    thumb: dummy,
  },
]

export const sceneData218 = [
  {
    id: 24377,
    name: 'Trundle Bed',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData88 = {
  tokenUrl: 'c30677d5-60a9-324f-826a-9d9bb7a99be2',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData88 = [
  {
    id: 1,
    name: 'Island Settee - Daybed',
    thumb: dummy,
  },
]

export const layoutData88 = [
  {
    id: 1,
    name: 'Island Settee - Daybed',
    thumb: dummy,
  },
]

export const sceneData88 = [
  {
    id: 24379,
    name: 'Island Settee - Daybed',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]

//////////////////////////////
export const configuratorData224 = {
  tokenUrl: 'f4ff7319-b309-3c55-ae94-29059a459393',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData224 = [
  {
    id: 1,
    name: 'Lattice Daybed',
    thumb: dummy,
  },
]

export const layoutData224 = [
  {
    id: 1,
    name: 'Lattice Daybed',
    thumb: dummy,
  },
]

export const sceneData224 = [
  {
    id: 24378,
    name: 'Lattice Daybed',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData407 = {
  tokenUrl: '0cd0533b-c1ae-3680-a3f6-32756ad8b022',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData407 = [
  {
    id: 1,
    name: 'Dottie Single Credenza',
    thumb: dummy,
  },
]

export const layoutData407 = [
  {
    id: 1,
    name: 'Dottie Single Credenza',
    thumb: dummy,
  },
]

export const sceneData407 = [
  {
    id: 23989,
    name: 'Dottie Single Credenza',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData408 = {
  tokenUrl: 'a80e7ac3-df1a-305c-874f-49b91936021d',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData408 = [
  {
    id: 1,
    name: 'Dottie Double Credenza',
    thumb: dummy,
  },
]

export const layoutData408 = [
  {
    id: 1,
    name: 'Dottie Double Credenza',
    thumb: dummy,
  },
]

export const sceneData408 = [
  {
    id: 23990,
    name: 'Dottie Double Credenza',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData409 = {
  tokenUrl: '0d33727e-1e7f-3996-8c84-410585ba0e8d',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData409 = [
  {
    id: 1,
    name: 'Dottie Triple Credenza',
    thumb: dummy,
  },
]

export const layoutData409 = [
  {
    id: 1,
    name: 'Dottie Triple Credenza',
    thumb: dummy,
  },
]

export const sceneData409 = [
  {
    id: 23991,
    name: 'Dottie Triple Credenza',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData410 = {
  tokenUrl: 'e64fee90-9070-3a47-82df-bce84fdf1592',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData410 = [
  {
    id: 1,
    name: 'Claire Etagere - Painted',
    thumb: dummy,
  },
]

export const layoutData410 = [
  {
    id: 1,
    name: 'Claire Etagere',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Wood Knobs',
    thumb: dummy,
  },
]

export const sceneData410 = [
  {
    id: 24029,
    name: 'Claire Etagere - Painted',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24030,
    name: 'Claire Etagere Wood Knobs Painted',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]


//////////////////////////////
export const configuratorData411 = {
  tokenUrl: '38d6bf85-8c33-33f2-996e-78ffc05565aa',
  id: 1,
  name: 'Maine Cottage',
  arViewer: true,
  measureTool: true,
}

export const profileData411 = [
  {
    id: 1,
    name: 'Claire Etagere - Wooden',
    thumb: dummy,
  },
]

export const layoutData411 = [
  {
    id: 1,
    name: 'Claire Etagere',
    thumb: dummy,
  },
  {
    id: 2,
    name: 'Wood Knobs',
    thumb: dummy,
  },
]

export const sceneData411 = [
  {
    id: 24031,
    name: 'Claire Etagere Wood',
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 24032,
    name: 'Claire Etagere Wood Knobs',
    profileId: 1,
    layoutId: 2,
    thumb: dummy,
  },
]
